module.exports = function getResource(label, vars = []) {
    const resources = {
        Standard: `${vars[0] ? '' : 'View your '}Standard order.`,
        Pickup: `${vars[0] ? '' : 'View your '}Buy Online & Pick Up basket`,
        Sameday: `${vars[0] ? '' : 'View your '}Same-Day Delivery order.`,
        ShipToHome: `${vars[0] ? '' : 'View your '}Get It Shipped basket`
    };

    return resources[label];
};
